import { ContentAccordionProps, Props } from '../interfaces'
import { useEffect, useState } from 'react'

const useAccordion = ({ listAccordion, onChange }: Props) => {
  const [accordionItems, setAccordionItems] = useState<ContentAccordionProps[]>([])

  useEffect(() => {
    setAccordionItems(listAccordion)
  }, [listAccordion])

  function changeOpenedAccordion(index: number) {
    const updateAccordionItems = accordionItems.map((accordion, accodionIndex) => ({
      ...accordion,
      isOpen: accodionIndex === index ? !accordion.isOpen : false,
    }))

    setAccordionItems(updateAccordionItems)
    onChange?.(updateAccordionItems, updateAccordionItems.filter((acc) => acc.isOpen).length > 0)
  }

  return {
    accordionItems,
    changeOpenedAccordion,
  }
}

export default useAccordion
